import cfrUrl from '@/creditflowresearch/infrastructure/url';

const getHomepageMetaSchema = () => ({
  '@type': 'WebSite',
  url: cfrUrl.getUrl('/'),
  name: 'CreditFlow',
  description: 'Supersonic Insights and Analysis for Debt Capital Markets.',
});

export default getHomepageMetaSchema;
